import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Modal, Stack, TextField, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};

export default function SaveRunModal(props) {
  const [runName, setRunName] = useState("");
  const [runNotes, setRunNotes] = useState("");

  const handleRunNameChange = (e) => {
    setRunName(e.target.value);
  }

  const handleRunNotesChange = (e) => {
    setRunNotes(e.target.value);
  }

  const handleClose = () => {
    props.handleClose(runName, runNotes);
  }
  
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} alignItems='center' justifyContent='center'>
        <IconButton onClick={props.handleClose} aria-label="close" style={{position: "absolute", right: "10px", top:"10px"}}>
          <CloseIcon />
        </IconButton>
        <Stack spacing={2}>
          <Typography 
            id="modal-description"
            variant='h6'
          >
            Save groups
          </Typography>

          <TextField label="Name" onChange={handleRunNameChange} variant='outlined'/>
          <TextField label="Notes" onChange={handleRunNotesChange} variant='outlined'/>

          <Button onClick={() => props.saveGroups(runName, runNotes)} variant='contained'>
            Save
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
